export enum RadioNumberFilterOperation {
  IS_GREATER_THAN = 'IS_GREATER_THAN',
  IS_LESS_THAN = 'IS_LESS_THAN',
  IS_EXACTLY = 'IS_EXACTLY',
  IS_NOT = 'IS_NOT',
  IS_BETWEEN = 'IS_BETWEEN',
  IS_UNKNOWN = 'IS_UNKNOWN',
  HAS_ANY_VALUE = 'HAS_ANY_VALUE',
}

export const RadioNumberFilterOperationsWithoutSpecificValue = [
  RadioNumberFilterOperation.IS_UNKNOWN,
  RadioNumberFilterOperation.HAS_ANY_VALUE,
];

// We need to create all the types for typescript to be able to infer the type based on the operation property.

interface IsGreaterThanOperation {
  operation: RadioNumberFilterOperation.IS_GREATER_THAN;
  value: number;
}

interface IsLessThanOperation {
  operation: RadioNumberFilterOperation.IS_LESS_THAN;
  value: number;
}

interface IsOperation {
  operation: RadioNumberFilterOperation.IS_EXACTLY;
  value: number;
}

interface IsNotOperation {
  operation: RadioNumberFilterOperation.IS_NOT;
  value: number;
}

interface IsBetweenOperation {
  operation: RadioNumberFilterOperation.IS_BETWEEN;
  from: number;
  to: number;
}

interface IsUnknownOperation {
  operation: RadioNumberFilterOperation.IS_UNKNOWN;
}

interface HasAnyValueOperation {
  operation: RadioNumberFilterOperation.HAS_ANY_VALUE;
}

export type RadioNumberFilterValue =
  | IsGreaterThanOperation
  | IsLessThanOperation
  | IsOperation
  | IsNotOperation
  | IsBetweenOperation
  | IsUnknownOperation
  | HasAnyValueOperation;

export type RadioNumberFilterValueType = RadioNumberFilterValue | undefined;
